import { render, staticRenderFns } from "./NotificationSettingEdit.vue?vue&type=template&id=4052cb2a&scoped=true&lang=pug"
import script from "./NotificationSettingEdit.vue?vue&type=script&lang=ts"
export * from "./NotificationSettingEdit.vue?vue&type=script&lang=ts"
import style0 from "./NotificationSettingEdit.vue?vue&type=style&index=0&id=4052cb2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4052cb2a",
  null
  
)

export default component.exports